import { render, staticRenderFns } from "./smartScreenSetting.vue?vue&type=template&id=e1349620&scoped=true&"
import script from "./smartScreenSetting.vue?vue&type=script&lang=ts&"
export * from "./smartScreenSetting.vue?vue&type=script&lang=ts&"
import style0 from "./smartScreenSetting.vue?vue&type=style&index=0&id=e1349620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1349620",
  null
  
)

export default component.exports